<template> 

  <!-- Step 1) Enter an email -->
    <register-step-1 v-if="currentStep === 1 || !$route.params.step"></register-step-1>

  <!-- Step 2) Enter a password -->
    <register-step-2 v-else-if="currentStep === 2"></register-step-2>

  <!-- Step 3) Basics -->
    <register-step-3 v-else-if="currentStep === 3"></register-step-3>

  <!-- Step 4) Profile picture -->
    <register-step-4 v-else-if="currentStep === 4"></register-step-4>

  <!-- Step 6) Your focus Areas -->
    <register-step-5 v-else-if="currentStep === 5"></register-step-5>

  <!-- Step 7) Areas of Africa your interested in -->
    <register-step-6 v-else-if="currentStep === 6"></register-step-6>

  <!-- Step 8) Skills you have to offer -->
    <register-step-7 v-else-if="currentStep === 7"></register-step-7>

  <!-- Step 9) Big Idea (Optional) -->
    <register-step-8 v-else-if="currentStep === 8"></register-step-8>

  <!-- Step 10) Choose skills you need -->
    <register-step-9 v-else-if="currentStep === 9"></register-step-9>

  <!-- Step 11) Share on social networks-->
    <register-step-10 v-else-if="currentStep === 10"></register-step-10>

</template>

<script>
// import { db, auth } from '@/firebase'
import router from '@/router'

import RegisterStep1 from '@/pages/register/Register-Step-1'
import RegisterStep2 from '@/pages/register/Register-Step-2'
import RegisterStep3 from '@/pages/register/Register-Step-3'
import RegisterStep4 from '@/pages/register/Register-Step-4'
import RegisterStep5 from '@/pages/register/Register-Step-5'
import RegisterStep6 from '@/pages/register/Register-Step-6'
import RegisterStep7 from '@/pages/register/Register-Step-7'
import RegisterStep8 from '@/pages/register/Register-Step-8'
import RegisterStep9 from '@/pages/register/Register-Step-9'
import RegisterStep10 from '@/pages/register/Register-Step-10'

export default {
  data () {
    return {
      currentStep: 1,
      dbStep: null,
      // Step 1
      email: '',
      // random-' + Math.random().toString(36).slice(-8) + '@dev.miln.co
      // Step 3
      firstname: '',
      surname: '',
      organisation: '',
      sector: '',
      jobtitle: '',
      location: '',
      // Step X
      bigIdea: '',
      selectedCountries: [],
      selectedCountriesTags: []
    }
  },
  components: {
    RegisterStep1,
    RegisterStep2,
    RegisterStep3,
    RegisterStep4,
    RegisterStep5,
    RegisterStep6,
    RegisterStep7,
    RegisterStep8,
    RegisterStep9,
    RegisterStep10
  },
  created: function () {
    let step = this.$route.params.step
    let intstep = step.replace('step-', '')
    this.currentStep = parseInt(intstep)
  },
  watch: {
    currentStep: function (val) {
      router.replace('/register/step-' + val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register.vue?c81519b8